import { render, staticRenderFns } from "./EmployeeSlicesAdd.vue?vue&type=template&id=2904918c&scoped=true&"
import script from "./EmployeeSlicesAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeSlicesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904918c",
  null
  
)

export default component.exports